import { object, string, date, array, number } from 'yup';
import moment from 'moment';

import 'v3/utils/yup';

export default object({
  travelNumber: string()
    .required('Número da viagem é obrigatório.')
    .typeError('Número da viagem é obrigatório.'),
  cteNumber: string()
    .required('Número do CT-e é obrigatório.')
    .test('unique', 'Número do CT-e deve ser único.', function test(value) {
      const { cteList, emitteds } = this.options.context;
      return (
        !cteList.some((cte) => cte.cteNumber === value) &&
        !emitteds.some((cte) => cte.cte_number === value)
      );
    }),

  issuedAt: date()
    .transform((_value, originalValue) => moment(originalValue, 'DD/MM/YYYY HH:mm').toDate())
    .required('Data de emissão do CT-e é obrigatória.')
    .typeError('Data de emissão do CT-e é obrigatória.'),
  invoices: array()
    .required('Você deve inserir pelo menos uma nota fiscal.')
    .min(1, 'Você deve inserir pelo menos uma nota fiscal.')
    .of(
      object({
        key: string()
          .required('Você deve preencher a chave dessa nota fiscal.')
          .test('unique', 'Chave da nota fiscal deve ser única.', function test(value) {
            const { cteList } = this.options.context;
            return !cteList?.some((cte) =>
              cte?.invoices?.some((invoice) => invoice?.key === value),
            );
          }),
        serie: number()
          .required('Você deve preencher a série dessa nota fiscal.')
          .typeError('Você deve preencher a série dessa nota fiscal.'),
      }).uniqueProperty('key', 'Chave da nota fiscal deve ser única.'),
    ),
  destination: object().required('Destino é obrigatório.').typeError('Destino é obrigatório.'),
});
